import { Outlet } from '@tanstack/react-router'

import { ErrorPage } from '@/pages/error'

import { UserSettings } from '@/app/providers'

export const ProtectedLayout = (): React.ReactNode => {
    return (
        <UserSettings
            fallback={(title, description, error) => (
                <ErrorPage description={description} error={error} title={title} />
            )}
        >
            <Outlet />
        </UserSettings>
    )
}
